import { changeRandomImage } from "../module";

changeRandomImage();
